import React from 'react'
import _ from 'lodash'
import { SearchIcon, UserIcon } from '~/assets/svg/index'
import NavLink from '~/elements/navLink'
import popup from '~/views/Popup/popup'
import { logout } from '~/redux/user/helpers'
import { logoutUser } from '~/tools/analytics/cleverTap'
import { localizeTitle } from '~/tools/localization'
import connect from '~/tools/connect'
import userStore from "~/redux/user/store"

import './style.css'

class Masthead02 extends React.Component {
  constructor() {
    super()

    this.state = {
      openSideNav: false
    }

    this.openSideNav = this.openSideNav.bind(this)
    this.closeSideNav = this.closeSideNav.bind(this)
    this.onLogoutClick = this.onLogoutClick.bind(this)

    this.primaryCta = _.get(window.settings, 'navigation.settings.primaryCta', {}) 
    this.setPrimaryLinkGroups()
    this.userLinks = _.get(window.settings, 'navigation.user', [])
    this.networks = _.get(window.settings, 'navigation.network', [])
  }
  
  setPrimaryLinkGroups() {
    this.primaryLinks = _.get(window.settings, 'navigation.primary', [])
    const halfLengthOfLinks = Math.ceil(this.primaryLinks.length / 2)
    this.leftPrimaryLinks = this.primaryLinks.slice(0, halfLengthOfLinks)
    this.rightPrimaryLinks = this.primaryLinks.slice(halfLengthOfLinks, this.primaryLinks.length)
  }

  render() {
    const backgroundLogoStyle = {
      background: `url(${this.logo}) no-repeat`,
      backgroundSize: 'contain',
      backgroundPosition: 'center'
    }

    return(
      <nav className="masthead02">
        <nav className="mobile">
          <div onClick={ this.openSideNav } className="burger">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <a className="logo" href="/" style={ backgroundLogoStyle }></a>
          <button className="search-btn" onClick={ popup.search }>
            <SearchIcon />
          </button>
        </nav>

        { this.state.openSideNav &&
          <nav className="side-nav">
            <div className="top-section">
              <button className="close-btn" onClick={ this.closeSideNav }>
                <i role="presentation" className="ion-close"/>
              </button>
              { this.networks.length &&
                <div className="network-section">
                  <div className="label">Proud Home of The</div>
                  <div className="networks">
                    { this.renderNetworks() }
                  </div>
                </div>
              }
            </div>
            <div className="bottom-section">
              <div className="social-icons">
                { this.renderSocialIcons() }
              </div>
              { this.renderLinks(this.primaryLinks) }
              { this.renderUserActions() }
              { this.state.user &&
                <button className="logout-btn" onClick={ e => this.onLogoutClick(e) }>LOG OUT</button>
              }
              { this.shouldRenderSubscribeBtn() && this.subscribeBtn() }
            </div>
          </nav>
        }

        <nav className="desktop">
          <div className="top-section">
            <div className="top-section__left">
              { this.networks.length &&
                <span className="label">Proud Home of The</span>
              }
              { this.renderNetworks() }
            </div>
            <div className="top-section__right">
              <button aria-label="Search" className="search-btn" onClick={ popup.search }>
                <SearchIcon />
              </button>
              { this.renderSocialIcons() }
              { this.renderUserActions() }
              { this.shouldRenderSubscribeBtn() && this.subscribeBtn() }
            </div>
          </div>
          <div className="bottom-section">
            <div className="bottom-section__left">
              { this.renderLinks(this.leftPrimaryLinks) }
            </div>
            <div className="bottom-section__middle">
              <a aria-label={window.settings.site + ' Home'} href="/">
                <img src={ this.logo } alt={window.settings.site} />
              </a>
            </div>
            <div className="bottom-section__right">
              { this.renderLinks(this.rightPrimaryLinks) }
            </div>
          </div>
        </nav>
      </nav>
    )
  }

  openSideNav() {
    this.setState({ openSideNav: true })
  }

  closeSideNav() {
    this.setState({ openSideNav: false })
  }

  renderNetworks() {
    return _.map(this.networks, (network, idx) => {
      let linkBgStyle = {
        background: `url(${network.icon}) no-repeat`,
        backgroundSize: 'contain',
        backgroundPosition: 'center'
      }

      return <a aria-label={network.title} style={ linkBgStyle } key={ idx } target="_blank" className="network" href={ network.url }></a>
    })
  }

  renderSocialIcons() {
    const socialNetworks = _.get(window.settings, 'socialMedia', {})
    return _.map(socialNetworks, (network, key) => (
      <a aria-label={key} className="social-link" key={ key } href={ network.url } target="_blank">
        <i role="presentation" className={`ion-social-${key}`}/>
      </a>
    ))
  }

  renderUserActions() {
    return this.state.user ? this.accountMenu() : this.loginBtn()
  }

  shouldRenderSubscribeBtn() {
    if (window.settings.serviceType !== 'SVOD')
      return false
    if (!this.state.user)
      return true
    if (this.state.user && !this.state.user.isSubscribed)
      return true

    return false
  }

  subscribeBtn() {
    if (this.primaryCta.placement !== "Masthead") 
      return

    return (
      <a href={ this.primaryCta.url } className="cta subscribe-button">
        { this.primaryCta.ctaText }
      </a>
    )
  }

  loginBtn() {
    return(
      <button onClick={ popup.login } className="cta login-button"> 
        Login
      </button>
    )    
  }

  onLogoutClick(evt) {
    evt.preventDefault()
    logout().then(_ => {
      logoutUser()
    })
  }

  accountMenu() {
    let links = _.map(this.userLinks, (link, idx) => <a key={idx} href={link.url}>{localizeTitle(link)}</a>) 
    links.push(<a key={this.userLinks.length} onClick={ e => this.onLogoutClick(e) }>Log Out</a>)

    return (
      <div className="user-menu">
        <UserIcon/>
        <div className="user-menu__links">
          { links }
        </div>
      </div>
    )
  }

  renderLinks(links) {
    return _.map(links, (link, idx) => (
      <NavLink key={ idx } link={ link }/>
    ))
  }

  get logo() {
    return _.get(window.settings, 'images.desktopLogo', '')
  }
}

connect(Masthead02, (state) => ({ user: state.user }), userStore)

export default Masthead02;